import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, computed, OnInit, signal } from '@angular/core';
import { ActivatedRoute, Params, Router, RouterLink } from '@angular/router';
import { ButtonDirective, CardBodyComponent, CardComponent, CardFooterComponent, CardHeaderComponent, ColComponent, ColDirective, ContainerComponent, DropdownComponent, DropdownItemDirective, DropdownMenuDirective, DropdownToggleDirective, FormModule, IColumn, ProgressBarDirective, ProgressComponent, RowComponent, SmartTableComponent, SmartTableModule, TemplateIdDirective, ToastBodyComponent, ToastComponent, ToasterComponent, ToastHeaderComponent, WidgetStatAComponent, WidgetStatBComponent } from '@coreui/angular-pro';

import { ChartjsComponent } from '@coreui/angular-chartjs';
import { cilArrowTop, cilOptions } from '@coreui/icons';
// import { getStyle } from '@coreui/coreui/dist/js/coreui-utilities';
import { IconDirective } from '@coreui/icons-angular';

import { FormsModule } from '@angular/forms';
import { ChartData, ChartOptions } from 'chart.js';
import { Subscription } from 'rxjs';
import { RangeFilterComponent } from "../../components/range-filter/range-filter.component";
import { DepotUtilizationStatistics, LeagueDepotData, LeagueRegionData, VehicleUtilizationStatistics } from '../../models/depot-insight.model';
import { IQueryFilterRange } from '../../models/vehicle-status.model';
import { GlobalDataService } from '../../services/global-data.service';
import { NetworkSummaryService } from '../../services/network-summary.service';
import { VehicleStatusService } from '../../services/vehicle-status.service';
import { NavItemsService } from '../services/nav-service';
import { ITooltipItemRaw } from '../../models/charts.model';
import colors from '../../constants/colors.constants';
import { INavDataExtended } from '../../models/depart-region-depot.model';

@Component({
  selector: 'app-network-summary',
  standalone: true,
  templateUrl: './department-summary.component.html',
  styleUrl: './department-summary.component.scss',
  imports: [
    CommonModule,
    FormsModule,
    ChartjsComponent,
    ContainerComponent,
    RowComponent,
    ColComponent,
    CardComponent,
    CardBodyComponent,
    CardHeaderComponent,
    CardFooterComponent,
    CommonModule,
    SmartTableModule,
    SmartTableComponent,
    TemplateIdDirective,
    ColDirective,
    FormModule,
    RangeFilterComponent,
    RouterLink,
    ProgressComponent,
    ToasterComponent,
    ToastComponent,
    ToastHeaderComponent,
    ToastBodyComponent
  ]
})

export class NetworkSummaryComponent implements OnInit {
  departmentId! : string
  icons = { cilOptions, cilArrowTop };

  
  mostFrequentlyUsedVehicles: VehicleUtilizationStatistics[] = [];
  unutilisedVehiclesData: DepotUtilizationStatistics[] = [];

  leagueRegionData: LeagueRegionData[] = [];
  leagueDepotData: LeagueDepotData[] = [];

  rangeSelector: IQueryFilterRange = IQueryFilterRange.ThisYear


  networkUtilizationChartOptions: ChartOptions = {
    interaction: {
      intersect: false,
      mode: 'index',
    },
    scales: {
      y: {
        suggestedMin: 0,
        suggestedMax: 100,
      },
    },
    parsing: {
      xAxisKey: 'label',
      yAxisKey: 'averagePercentageOfUtilization',
    },
    // TODO: Need to figure out how to get newlines in this [02282025]
    plugins: {
      tooltip: {
        callbacks: {
          title: function(tooltipItems) {
            return [
              `${tooltipItems[0].label} (%)`
            ];
          }
          ,
          // label: function(tooltipItem) {
          //   console.log('tooltipItem: ', tooltipItem)
          //   const dataPoint: ITooltipItemRaw = tooltipItem.raw as ITooltipItemRaw;
          //   return [
          //     `Item: ${dataPoint.label}, Average Utilisation: ${dataPoint.averagePercentageOfUtilization}%`
          //   ];
          // },
        },
      }
    },
  };
  networkUtilisationData: ChartData | null = {
    labels: [],
    datasets: [],
  };

  vehicleUtilizationData: ChartData = {
    labels: [],
    datasets: [
      {
        data: [], // Example distribution
        backgroundColor: [], // Adjust colors to match the chart
      },
    ],
  };

  vehicleStatusData: ChartData = {
    labels: [],
    datasets: [
      {
        data: [], // Example data representing VOR, In use, and Available
        backgroundColor: [], // Corresponding colors for VOR, In Use, Available
      },
    ],
  };

  routeSubscription: Subscription;


  handleChartRef($chartRef: any) {
    if ($chartRef) {
      setTimeout(() => {
        $chartRef?.update();
      }, 3000);
    }
  }


  widgetData: any = {};
  widgetOptions: any = {};

  monthLabels = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
    'January',
    'February',
    'March',
    'April'
  ];

  widgetDatasets = [
    {
      label: 'My First dataset',
      backgroundColor: 'transparent',
      borderColor: 'rgba(255,255,255,.55)',

      data: [65, 59, 84, 84, 51, 55, 40]
    }
  ];

  optionsDefault = {
    plugins: {
      legend: {
        display: false
      }
    },
    maintainAspectRatio: true,
    scales: {
      x: {
        grid: {
          display: false,
          drawBorder: false
        },
        ticks: {
          display: false
        }
      },
      y: {
        min: 30,
        max: 89,
        display: false,
        grid: {
          display: false
        },
        ticks: {
          display: false
        }
      }
    },
    elements: {
      line: {
        borderWidth: 1,
        tension: 0.4
      },
      point: {
        radius: 4,
        hitRadius: 10,
        hoverRadius: 4
      }
    }
  };

  screenTitle = 'Average Utilisation Score';
  expectedScoreAvg: number | undefined = 0;

  // Widget B
  widgetBValue = signal<number>(75.9);
  widgetBValuePercent = computed(() => `${this.widgetBValue()}%`);

  // Table coloumn configs
  leagueDepotColumns: (IColumn | string)[] = [
    {
      label: 'Depot',
      key: 'depot_name',
      filter: true,
      sorter: true,
      _labelTemplateId: 'all',
      _style: { width: '20%' },
      _props: { class: 'fw-bold' }
    },
    { label: 'Today\'s Utilisation (%)', key: 'total_today_snapshot_count', _labelTemplateId: 'all', filter: false, sorter: false, _style: { width: '15%' }, _classes: 'text-muted small' },
    { label: 'Average Utilisation (%)', key: 'total_snapshot_count_in_range', _labelTemplateId: 'all', filter: false, sorter: false, _style: { width: '15%' }, _classes: 'text-muted small' },
    { label: 'Total Unused Count', key: 'total_utilized_count_in_range', _labelTemplateId: 'all', filter: false, sorter: false, _style: { width: '15%' }, _classes: 'text-muted small' },
    // { label: 'VOR Count Today', key: 'today_vor_count', _labelTemplateId: 'all', filter: false, sorter: true, _style: { width: '15%' }, _classes: 'text-muted small' },
  ];
  leagueRegionColumns: (IColumn | string)[] = [
    {
      label: 'Region',
      key: 'region',
      filter: true,
      _labelTemplateId: 'all',
      _style: { width: '20%' },
      _props: { class: 'fw-bold' }
    },
    { label: 'Today\'s Utilisation (%)', key: 'total_today_snapshot_count', _labelTemplateId: 'all', filter: false, sorter: false, _style: { width: '15%' }, _classes: 'text-muted small' },
    { label: 'Average Utilisation (%)', key: 'total_snapshot_count_in_range', _labelTemplateId: 'all', filter: false, sorter: false, _style: { width: '15%' }, _classes: 'text-muted small' },
    { label: 'Total Unused Count', key: 'total_utilized_count_in_range', _labelTemplateId: 'all', filter: false, sorter: false, _style: { width: '15%' }, _classes: 'text-muted small' },
    // { label: 'VOR Count Today', key: 'today_vor_count', _labelTemplateId: 'all', filter: false, sorter: true, _style: { width: '15%' }, _classes: 'text-muted small' },
  ];
  unutilisedByDayColumns: (IColumn | string)[] = [
    {
      label: 'Depot',
      key: 'depot_name',
      filter: true,
      _labelTemplateId: 'all',
      _style: { width: '20%' },
      _props: { class: 'fw-bold' }
    },
    { label: 'Unused Count', key: 'unutilized_count', _labelTemplateId: 'all', filter: false, sorter: false, _style: { width: '15%' }, _classes: 'text-muted small' },
    { label: 'Date', key: 'snapshot_date', _labelTemplateId: 'all', filter: false, sorter: true, _style: { width: '15%' }, _classes: 'text-muted small' },
  ];
  frequentUnutilisedColumns: (IColumn | string)[] = [
    {
      label: 'Vehicle',
      key: 'vehicle_registration',
      filter: true,
      _labelTemplateId: 'all',
      _style: { width: '40%' },
      _props: { class: 'fw-bold' }
    },
    { label: 'Depot', key: 'vehicle_depot', _labelTemplateId: 'all', filter: false, sorter: false, _style: { width: '40%' }, _classes: 'text-muted small' },
    { label: 'Unused Count', key: 'unutilized_count', _labelTemplateId: 'all', filter: false, sorter: false, _style: { width: '20%' }, _classes: 'text-muted small' },
  ];


  // Toaster 
  visible = signal(false);
  percentage = signal(0);

  toggleToast() {
    this.visible.update((value) => !value);
  }

  onToasterVisibleChange($event: boolean) {
    this.visible.set($event);
    this.percentage.set(this.visible() ? this.percentage() : 0);
  }

  onToasterTimerChange($event: number) {
    this.percentage.set($event * 25);
  }


  constructor(
    private route: ActivatedRoute,
    private networkSummaryService: NetworkSummaryService,
    private globalData: GlobalDataService,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private vehicleStatusService: VehicleStatusService,
    private navDataService: NavItemsService,
  ) {
    this.routeSubscription = this.route.params.subscribe(res => this.onRouteChange(res));
    this.rangeSelector = this.route.snapshot.queryParams["range"] || "1"
  }

  handleRouteFilterChange($event: any) {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        range: $event.currentTarget?.value
      },
      queryParamsHandling: "merge"
    }).then(res => {
      this.onRouteChange(this.route.snapshot.params)
    })
  }

  async onRouteChange(params: Params): Promise<void> {
    const { departmentId } = params
    this.departmentId = departmentId;

    console.log(departmentId)

    const range = this.route.snapshot.queryParamMap?.get("range") as IQueryFilterRange

    if (!departmentId || departmentId?.length <= 0) {
      this.router.navigate(["/"])
    }

    const _params = this.globalData.generateApiQueryParams({
      range: range as IQueryFilterRange
    });
    _params['department_id'] = departmentId.toString();


    this.navDataService.navDataReceivedObservable.subscribe(() => {
      this.screenTitle = `${this.navDataService.findDepartmentName(parseInt(departmentId))} Average Utilisation Score `;
      this.expectedScoreAvg = this.navDataService.findDepartmentAverageScoreRequired(parseInt(departmentId));

    });

    this.networkSummaryService.getUtilizationStatistics(_params)
      .then(res => {
        this.networkUtilisationData = null;
        this.cdr.detectChanges()

        this.networkUtilisationData = this.networkSummaryService.refactorUtilizationDataForLineGraph(res, range)
        // Generating a dataset for the average expected score
        let expectedScoreData: any[] = [];
        this.networkUtilisationData.datasets[0].data.forEach((dataPoint) => {
          expectedScoreData.push({
            // The ts-ignore is because the data-point is guaranteed to be an object here
            // @ts-ignore
            ...dataPoint,
            averagePercentageOfUtilization: this.expectedScoreAvg,
          })
        })
        console.log({ expectedScoreData })
        this.networkUtilisationData.datasets.push({
          label: 'Expected Target Average Percent',
          borderColor: colors.expectedNetworkAvg,
          fill: false,
          tension: 0.4,
          data: expectedScoreData,
        })
        console.log("change")

        this.cdr.detectChanges()
      })

    this.networkSummaryService.getVehicleStatusData(_params)
      .then(res => {
        this.vehicleStatusData = this.networkSummaryService.refactorVehicleStatusData(res);
        this.cdr.detectChanges();
      })

    this.networkSummaryService.getVehicleUtilization(_params)
      .then(res => {
        this.mostFrequentlyUsedVehicles = this.networkSummaryService.refactoryVehicleUtilizationData(res)
        this.cdr.detectChanges();
      })

    this.networkSummaryService.getDepotUtilizationStatistics(_params)
      .then(res => {
        this.unutilisedVehiclesData = res;
        this.cdr.detectChanges();
      })

    this.networkSummaryService.getDepartmentLeagueTableStatsDepots(departmentId, _params)
      .then(res => {
        this.leagueDepotData =  res;
        // this.leagueDepotData = res.map((item) => {
        //   const { depot_id, ...rest } = item;

        //   return rest as LeagueDepotData
        // })
        this.cdr.detectChanges()
      })

    this.networkSummaryService.getDepartmentLeagueTableStatsRegions(departmentId, _params)
      .then(res => {
        this.leagueRegionData = res.map((item: any) => {
           item = {...item, region: {region_id: item.region_id, region_name: item.region_name }, }
          // console.log(item)
          return item
        })

        this.cdr.detectChanges()
      })

    this.widgetData = {
      labels: this.monthLabels.slice(0, 7),
      datasets: this.widgetDatasets
    };

    // Setup first graph
    this.vehicleStatusService.getVehicleUtilizationStatistics(_params).subscribe((data) => {
      const { vehicleUtilizationData } = this.vehicleStatusService.refactorVehicleStatsDataForGraphs(data)
      this.vehicleUtilizationData = vehicleUtilizationData;

      this.cdr.detectChanges()
    })

    this.widgetOptions = this.optionsDefault;
  }

  

  gotoDepot(item: LeagueDepotData) {
    const region = this.navDataService.findRegionByDepotId(parseInt(this.departmentId), item.depot_id);
    debugger
    if (region) {
      const route = `/department/${this.departmentId}/region/${region.id}/depot/${item.depot_id}/`;
      this.router.navigate([route]);
    } else {
      this.toggleToast();
    }
   
  }


  ngOnInit() {
   
  }

  ngOnDestroy() {
    this.routeSubscription.unsubscribe()
  }

}
